import React, { Component } from 'react';
import {Button, Dimmer, Header, Icon, Loader, Modal, Table} from "semantic-ui-react";
import moment from 'moment';
import { getOpenIssues, saveOpenIssueNotes, getNotes } from "../../redux/modules/downTimeTracker";
import { connect } from 'react-redux';
import ViewNotes from './ViewNotes'
import {formatMinutes} from "../../utils/commonutils";


class DownTimeIssuesPopUp extends Component {
    state = { loading: false, issuesList: [], notesPopupModal: false, modalData: {}, notes: [] }
    componentWillMount = () => {
        this.getOpenIssues()
    }

    getOpenIssues = () => {
        const {dispatch, applicationList} = this.props
        this.setState({loading: true})
        dispatch(getOpenIssues(applicationList)).then(res => {
            this.setState({issuesList: res})
            this.setState({loading: false})
        })
    }

    submitForm = (payload) => {
        const {dispatch} = this.props
        dispatch(saveOpenIssueNotes(payload)).then( res => {
            window.location.reload()
        })
    }

    openNotesPopUpModal = (data) => {
        const {dispatch} = this.props
        this.setState({loading: true})
        dispatch(getNotes(data.id)).then( res => {
            this.setState({ notesPopupModal: true, notes: res });
            this.setState({loading: false})
        })
    }
    hideNotesPopUpModal = () => {
        this.setState({ notesPopupModal: false });
    }
    render() {
        const { hideModal } = this.props;
        const { loading, issuesList, notesPopupModal, modalData, notes } = this.state;
        return(
            <Modal
                closeIcon
                open={true}
                onClose={hideModal}
                centered={true}
                size='fullscreen'
            >
                <Header content="Pages currently down"/>

                <Modal.Content>
                    <div className="ui card">
                        <div className="content pb0 mb10" style={{height: "65vh !important", overflowY: "auto"}}>
                            <Table basic={true}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell content="Status"/>
                                        <Table.HeaderCell content="Application"/>
                                        <Table.HeaderCell content="Down Time Start"/>
                                        <Table.HeaderCell content="Brands"/>
                                        <Table.HeaderCell content="Practices"/>
                                        <Table.HeaderCell content="What Is Down"/>
                                        <Table.HeaderCell content="Reason For Being Down"/>
                                        <Table.HeaderCell content="What to do in mean time"/>
                                        <Table.HeaderCell content="Project Resolution Date and Time"/>
                                        <Table.HeaderCell content="Notes"/>
                                        <Table.HeaderCell content="Time Down"/>
                                        <Table.HeaderCell content="Error Source"/>
                                        <Table.HeaderCell content="How was it reported	"/>
                                        <Table.HeaderCell content="Notification Group"/>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {loading && <Dimmer active inverted>
                                        <Loader inverted>Loading</Loader>
                                    </Dimmer>
                                    }
                                    {
                                        issuesList && issuesList.length ?
                                            issuesList.map((data, key) =>
                                                <Table.Row key={data.id}>
                                                    <Table.Cell>{data.status}</Table.Cell>
                                                    <Table.Cell>{data.application}</Table.Cell>
                                                    <Table.Cell>{moment(data.downTimeStart).format('D MMMM YYYY HH:mm')}</Table.Cell>
                                                    <Table.Cell>{data.brands}</Table.Cell>
                                                    <Table.Cell>{data.practices}</Table.Cell>
                                                    <Table.Cell>{data.whatIsDown}</Table.Cell>
                                                    <Table.Cell>{data.reasonForBeingDown}</Table.Cell>
                                                    <Table.Cell>{data.whatToDoMeanTime}</Table.Cell>
                                                    <Table.Cell>{data.resolutionDateTime!==null?moment(data.resolutionDateTime).format('D MMMM YYYY HH:mm'):""}</Table.Cell>
                                                    <Table.Cell>
                                                        <Button style={{padding: '20px 15px'}} onClick={() => this.openNotesPopUpModal(data)}> <Icon name="book"/> Notes</Button>
                                                        {
                                                            notesPopupModal && <ViewNotes submitForm={this.submitForm} issue={modalData} notes={notes} hideModal={this.hideNotesPopUpModal}/>
                                                        }
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {
                                                            data.resolutionDateTime !== null ?
                                                                formatMinutes(moment.duration(moment(data.resolutionDateTime).diff(moment(data.downTimeStart))).asMinutes()):
                                                                    data.timeDown
                                                        }
                                                    </Table.Cell>
                                                    <Table.Cell>{data.errorSource}</Table.Cell>
                                                    <Table.Cell>{data.howWasItReported}</Table.Cell>
                                                    <Table.Cell>{data.notificationGroup}</Table.Cell>
                                                </Table.Row>
                                            ) :
                                            <Table.Row>
                                                <Table.Cell colSpan={14} className="text-center" content="No Data"/>
                                            </Table.Row>
                                    }
                                </Table.Body>
                            </Table>
                        </div>
                    </div>
                </Modal.Content>
            </Modal>
        )
    }
}
export default connect()(DownTimeIssuesPopUp)